import { render, staticRenderFns } from "./BotSettingsView.vue?vue&type=template&id=5671f9c4&scoped=true"
import script from "./BotSettingsView.vue?vue&type=script&setup=true&lang=js"
export * from "./BotSettingsView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BotSettingsView.vue?vue&type=style&index=0&id=5671f9c4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5671f9c4",
  null
  
)

export default component.exports